exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-2e15e290] .handler{font-weight:600}[data-v-2e15e290] .body,[data-v-2e15e290] .handler{font-size:.875rem}.accordion[data-v-2e15e290]{border-bottom:.0625rem solid #e8e8e8}@media (min-width:576px){.accordion[data-v-2e15e290]{border-bottom:0}}", ""]);

